import type { RankingPlayerRow } from '@/hooks/useRanking';

export const PAGE_SIZE = 11;

export type RaceFilter = '' | 'chinese' | 'euro';

export interface MasteryOption {
  value: string;
  labelKey: string;
}

export const MASTERY_BY_RACE: Record<'chinese' | 'euro', MasteryOption[]> = {
  chinese: [
    { value: 'BICHEON', labelKey: 'ranking_mastery_bicheon' },
    { value: 'PACHEON', labelKey: 'ranking_mastery_pacheon' },
    { value: 'HEUKSAL', labelKey: 'ranking_mastery_heuksal' },
  ],
  euro: [
    { value: 'WARRIOR', labelKey: 'ranking_mastery_warrior' },
    { value: 'ROGUE', labelKey: 'ranking_mastery_rogue' },
    { value: 'WIZARD', labelKey: 'ranking_mastery_wizard' },
  ],
};

export function getRaceFromRefObjId(refObjId: number): RaceFilter {
  return refObjId < 3000 ? 'chinese' : 'euro';
}

export function filterRankingRows(
  rows: RankingPlayerRow[],
  search: string,
  race: RaceFilter,
  mastery: string,
): RankingPlayerRow[] {
  const term = search.trim().toLowerCase();

  return rows.filter((row) => {
    const rowRace = getRaceFromRefObjId(Number(row.RefObjID));
    if (race && rowRace !== race) return false;
    if (mastery && row.MasteryName !== mastery) return false;
    if (term && !row.CharName16.toLowerCase().includes(term)) return false;
    return true;
  });
}

export function paginateRows<T>(rows: T[], page: number, pageSize = PAGE_SIZE): T[] {
  const start = (page - 1) * pageSize;
  return rows.slice(start, start + pageSize);
}

export function totalPages(count: number, pageSize = PAGE_SIZE): number {
  return Math.max(1, Math.ceil(count / pageSize));
}

export function buildPageList(current: number, total: number): (number | 'ellipsis')[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const pages: (number | 'ellipsis')[] = [1];

  if (current > 3) pages.push('ellipsis');

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i++) pages.push(i);

  if (current < total - 2) pages.push('ellipsis');

  pages.push(total);
  return pages;
}
